import { useEffect, useState } from "react";
import PageTitle from "../../../common/PageTitle";
import { apiConstants, getGeneric, postGeneric } from "../../../common/constants";
import { getMerchant } from "../../../helpers/ReduxHelpers";
import { useSnackbar } from "notistack";
import { Box, Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import RHFMultipleSelectField from "../../../common/hook-form/RHFMultipleSelectField";
import { FormProvider } from "../../../common/hook-form";
import { useForm } from "react-hook-form";
import Loader from "../../../common/Loader";
import { pageContainerSx, filterBarSx, primaryBtnSx } from '../../../styles/patterns';

const CodOnHoldConfig = () => {
    const { enqueueSnackbar } = useSnackbar();
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''
    const [storeNames, setStoreNames] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(0);

    const methods = useForm({
        defaultValues: {
            selectedStores: []
        },
    });

    const { handleSubmit, reset } = methods;

    useEffect(() => {
        const fetchMerchantData = async () => {
            setIsLoading(true);
            if (!merchantId) return;
            try {
                const [storeNamesRes, merchantDetailsRes] = await Promise.all([
                    getGeneric(`${apiConstants.GET_UNIQUE_STORE_NAMES}?merchantOid=${merchantId}`),
                    getGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantId}`)
                ]);

                const storeNamesData = storeNamesRes?.data || [];
                const merchantDetailsData = merchantDetailsRes?.data?.codOnHoldConfig || {};

                setStoreNames(storeNamesData);

                // Set default form values once both are available
                const selectedStores = storeNamesData.filter(store =>
                    merchantDetailsData?.storeNames?.includes(store)
                );

                reset({ selectedStores });

            } catch (error) {
                console.error(error);
                enqueueSnackbar(error?.message || 'Something went wrong', { variant: 'error' });
            } finally {
                setIsLoading(false);
            }
        };

        fetchMerchantData();
    }, [merchantId, reload]);

    const onSubmit = async (data) => {
        setIsSubmitting(true);
        try {
            const response = await postGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantId}/codOnHold`, {
                isActive: true,
                storeNames: data.selectedStores
            })
            setReload(prev => prev + 1);
            if (response?.status === 200) {
                enqueueSnackbar('COD On Hold Configuration updated successfully', { variant: 'success' });
            } else {
                enqueueSnackbar('Something went wrong', { variant: 'error' });
            }
        } catch (error) {
            enqueueSnackbar(error?.message || 'Something went wrong', { variant: 'error' });
        } finally {
            setIsSubmitting(false);
        }
    }

    // Create options for the select field
    const storeOptions = storeNames.map(storeName => ({
        label: storeName,
        value: storeName
    }));

    return (
        <>
            {isLoading && <Loader />}
            <Box sx={pageContainerSx}>
                <PageTitle subTitle="Select store names that should have COD orders placed on hold">COD On Hold Configuration</PageTitle>
                <Box sx={filterBarSx}>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={6}>
                                <RHFMultipleSelectField
                                    width="100%"
                                    name="selectedStores"
                                    variant="outlined"
                                    label="Select Store Names"
                                    options={storeOptions}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                <LoadingButton
                                    loading={isSubmitting}
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                    sx={primaryBtnSx}
                                >
                                    Submit
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Box>
            </Box>
        </>
    )
}

export default CodOnHoldConfig;
